export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const KEYCLOAK_CONFIG = {
  auth_server_url: process.env.REACT_APP_KEYCLOAK_AUTH_SERVER_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID
}
export const SENTRY_URL = process.env.REACT_APP_SENTRY_URI;



// WEBPACK FOOTER //
// ./src/settings.js